import type { ListBuilderList } from '../../../types';
import { createMerchandiserColumns } from '../columns';

/**
 * Inactive merchandisers list (PD-13938) — units with status = inactive.
 */
export const inactiveMerchandisersList: ListBuilderList = {
	id: 'default-merchandisers-inactive',
	name: 'Inactive',
	type: 'default',
	active: true,
	cacheTTL: 600000,
	filterRules: {
		merchandiserStatus: {
			defaultValue: [{ id: 'inactive', label: 'Inactive' }],
		},
	},
	columns: createMerchandiserColumns(),
	defaultSortId: 'merchandiser-name',
	sortOrder: 3,
};
